import * as zod from 'zod';

const completionReason = zod.enum([
  'none',
  'learnedCompletion',
  'learnedFailure',
  'timeout',
  'stopCondition',
  'primaryStop',
]);

export type CompletionReason = zod.infer<typeof completionReason>;

export default zod.object({
  status: zod.enum(['idle', 'running', 'completed', 'failed']),
  lastCompletionReason: completionReason,
});
